import React from 'react';
import PropTypes from 'prop-types';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow 
} from '@mui/material';


const LandShareUtilisation = ({data}) => {

  const {
    psThreshold,
    acKwhPspd,
    dcKwhPspd,
  } = data;

  return (
    <div className="mb-6">
      <h3 className="text-[16px] font-semibold mb-2">Land Share</h3>
      <TableContainer>
        <Table 
          aria-label="Land share" 
          sx={{
            borderCollapse: 'separate',
            borderRadius: '15px',
            border: '1px solid rgb(224, 224, 224)',
          }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Utilisation for land share (per charging point per day)</TableCell>
              <TableCell align="right" sx={{fontWeight: 'bold'}}>kWh</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Target required</TableCell>
              <TableCell align="right">{`${psThreshold} kWh`}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Actual achieved (AC)</TableCell>
              <TableCell align="right">{`${acKwhPspd} kWh`}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Actual achieved (DC)</TableCell>
              <TableCell align="right">{`${dcKwhPspd} kWh`}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}


export default LandShareUtilisation;

LandShareUtilisation.propTypes = {
  data: PropTypes.object.isRequired,
};